import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export async function fetchModes() {
  const { data } = await api.get('/modes');
  return data;
}

export async function createSession(payload) {
  const { data } = await api.post('/sessions', payload);
  return data;
}

export async function listSessions(anonId, limit = 200) {
  const { data } = await api.get('/sessions', { params: { anon_id: anonId, limit } });
  return data;
}

export async function getSession(sessionId, anonId) {
  const { data } = await api.get(`/sessions/${sessionId}`, { params: { anon_id: anonId } });
  return data;
}

export async function deleteSession(sessionId, anonId) {
  const { data } = await api.delete(`/sessions/${sessionId}`, { params: { anon_id: anonId } });
  return data;
}

export async function reflectOnSession(sessionId, anonId) {
  const { data } = await api.post(`/sessions/${sessionId}/reflect`, { anon_id: anonId });
  return data;
}
